<template>
  <div>
    <template v-if="finishedLoading">
      <base-modal :id="id" v-if="member && member.attributes && member.attributes.v2_member_notification_setting"
                  :close-visible="false">
        <div class="notification-settings">
          <div class="controls">
            <b-button class="close" @click="closeModal(id)">
              <font-awesome-icon :icon="['fal', 'times-circle']"></font-awesome-icon>
            </b-button>
          </div>

          <template>
            <div class="header">
              <h5 class="text-center">{{ $t('sidenav.emailSettingsModal.emailSettingsTitle') }}</h5>
              <p>{{ $t('sidenav.emailSettingsModal.emailSettingsDescription') }} {{ organizationName() }}</p>
            </div>

            <div class="toggle-section">
              <b-form-checkbox id="enable_email_notifications" switch
                              v-model="enable_email_notifications"></b-form-checkbox>
              <label for="enable_email_notifications">{{ $t('sidenav.emailSettingsModal.masterToggle') }}</label>
            </div>

            <div class="toggle-section">
              <b-form-checkbox id="community_risk_level_updates" switch
                              v-model="community_risk_level_updates"></b-form-checkbox>
              <label for="community_risk_level_updates">{{
                  $t('sidenav.emailSettingsModal.community_risk_level_updates')
                }}</label>
            </div>

            <div class="toggle-section">
              <b-form-checkbox id="health_status_reminders" switch v-model="health_status_reminders"></b-form-checkbox>
              <label for="health_status_reminders">{{
                  $t('sidenav.emailSettingsModal.health_status_reminders')
                }}</label>
              <b-button v-if="health_status_reminders" class="edit" @click="openNotificationPanelModal" :disabled="!isHealthNotificationsEnabled">
                Edit
              </b-button>
            </div>

            <div class="toggle-section">
              <b-form-checkbox id="overdue_assignment_reminders" switch
                              v-model="overdue_assignment_reminders"></b-form-checkbox>
              <label for="overdue_assignment_reminders">{{
                  $t('sidenav.emailSettingsModal.overdue_assignment_reminders')
                }}</label>
            </div>

            <div class="toggle-section">
              <b-form-checkbox id="risk_response_plan_updates" switch
                              v-model="risk_response_plan_updates"></b-form-checkbox>
              <label for="risk_response_plan_updates">{{
                  $t('sidenav.emailSettingsModal.risk_response_plan_updates')
                }}</label>
            </div>

            <div class="toggle-section">
              <b-form-checkbox id="alert_notifications" switch v-model="alert_notifications"></b-form-checkbox>
              <label for="alert_notifications">{{ $t('sidenav.emailSettingsModal.alert_notifications') }}</label>
            </div>
          </template>
        </div>

      </base-modal>
      <notification-panel/>
    </template>
    <spinner v-else/>
  </div>
</template>

<script>
import _ from 'lodash';
import {updateApi} from '@/services/api.service';
import {mapState} from 'vuex';
import LocaleHandling from '@/mixins/locale-handling';
import commonFunctions from '@/mixins/common';
import NotificationPreferenceService from '@/services/notification-preference.service';

export default {
  name: 'email-settings',
  mixins: [LocaleHandling, commonFunctions],
  components: {
    BaseModal: () => import('@/components/base-modal/base-modal.vue'),
    NotificationPanel: () => import('@/components/notification-panel/notification-panel'),
    Spinner: () => import('@/components/loading-spinner/loading-spinner'),
  },
  data() {
    return {
      enable_email_notifications: true,
      community_risk_level_updates: true,
      health_status_reminders: true,
      overdue_assignment_reminders: true,
      risk_response_plan_updates: true,
      alert_notifications: true,
      finishedLoading: false,
      isHealthNotificationsEnabled: true,
      debugLog: false,
    };
  },
  mounted() {
    this.reset();
  },
  props: {
    id: String,
    member: Object,
  },
  computed: {
    ...mapState(['defaultOrganization']),
  },
  methods: {
    reset() {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const outerParams = {timestamp: secondsSinceEpoch};
      this.finishedLoading = false;
      this.isHealthNotificationsEnabled = true;
      if (this.member && this.member.attributes && this.member.attributes.v2_member_notification_setting) {
        this.enable_email_notifications = this.member.attributes.enable_email_notifications;
        this.community_risk_level_updates = this.member.attributes.v2_member_notification_setting.community_risk_level_updates;
        this.health_status_reminders = this.member.attributes.v2_member_notification_setting.health_status_reminders;
        this.overdue_assignment_reminders = this.member.attributes.v2_member_notification_setting.overdue_assignment_reminders;
        this.risk_response_plan_updates = this.member.attributes.v2_member_notification_setting.risk_response_plan_updates;
        this.alert_notifications = this.member.attributes.v2_member_notification_setting.alert_notifications;
        if (this.defaultOrganization.data.attributes.health_notification_preference) {
          const healthNotificationPreference = this.defaultOrganization.data.attributes.health_notification_preference;
          const healthPreferenceId = healthNotificationPreference.id;
          this.log('EmailSettings -> reset', 'healthNotificationPreference', healthNotificationPreference);
          this.log('EmailSettings -> reset', 'healthPreferenceId', healthPreferenceId);
          NotificationPreferenceService.show(healthPreferenceId, outerParams).then(({ data }) => {
            this.log('EmailSettings -> reset -> NotificationPreferenceService.show', 'data', data);
            this.isHealthNotificationsEnabled = data.attributes.enabled;
          });
        }
      }
      this.log('EmailSettings -> reset', 'defaultOrganization', this.defaultOrganization);
      this.log('EmailSettings -> reset', 'isHealthNotificationsEnabled', this.isHealthNotificationsEnabled);
      setTimeout(() => {
        this.finishedLoading = true;
      }, 1000);
    },
    masterEmailToggle() {
      this.community_risk_level_updates = this.enable_email_notifications;
      this.health_status_reminders = this.enable_email_notifications;
      this.overdue_assignment_reminders = this.enable_email_notifications;
      this.risk_response_plan_updates = this.enable_email_notifications;
      this.alert_notifications = this.enable_email_notifications;
    },
    openNotificationPanelModal() {
      this.openModal('notification-panel-modal');
    },
    checkMasterToggle() {
      if (this.community_risk_level_updates) {
        this.enable_email_notifications = true;
      }
      if (this.health_status_reminders) {
        this.enable_email_notifications = true;
      }
      if (this.overdue_assignment_reminders) {
        this.enable_email_notifications = true;
      }
      if (this.risk_response_plan_updates) {
        this.enable_email_notifications = true;
      }
      if (this.alert_notifications) {
        this.enable_email_notifications = true;
      }

      if (this.community_risk_level_updates === false) {
        if (this.health_status_reminders === false) {
          if (this.overdue_assignment_reminders === false) {
            if (this.risk_response_plan_updates === false) {
              if (this.alert_notifications === false) {
                if (this.enable_email_notifications === true) {
                  this.enable_email_notifications = false;
                }
              }
            }
          }
        }
      }
    },
    organizationName() {
      return this.getOrganizationName(this.defaultOrganization.data);
    },
    // eslint-disable-next-line
    toggleCallback: _.debounce(function () {
      this.checkMasterToggle();
      this.save();
    }, 100),
    // eslint-disable-next-line
    save: _.debounce(function () {
      if (this.finishedLoading) {
        const params = {
          data: {
            attributes: {
              v2_member_notification_setting_attributes: {
                id: this.member.attributes.v2_member_notification_setting.id,
                community_risk_level_updates: this.community_risk_level_updates,
                health_status_reminders: this.health_status_reminders,
                overdue_assignment_reminders: this.overdue_assignment_reminders,
                risk_response_plan_updates: this.risk_response_plan_updates,
                alert_notifications: this.alert_notifications,
              },
              enable_email_notifications: this.enable_email_notifications,
            },
          },
        };
        updateApi(`members/${this.member.id}`, params);
      }
    }, 750),
  },
  watch: {
    enable_email_notifications() {
      this.log('EmailSettings -> EnableEmailNotifications watch', 'enable_email_notifications', this.enable_email_notifications);
      if (this.finishedLoading) {
        this.masterEmailToggle();
        this.toggleCallback();
      }
    },
    community_risk_level_updates() {
      this.toggleCallback();
    },
    health_status_reminders() {
      this.toggleCallback();
    },
    overdue_assignment_reminders() {
      this.toggleCallback();
    },
    risk_response_plan_updates() {
      this.toggleCallback();
    },
    alert_notifications() {
      this.toggleCallback();
    },
  },
};
</script>

<style scoped lang="scss">
.heading {
  padding-left: 1rem;
  display: block;
  box-sizing: border-box;
  background-color: #e9ecef;
  color: #5b7889;
  width: calc(100% + 2rem);
  margin-left: -1rem;
  font-size: 15px;
  text-transform: uppercase;
}

.header {
  text-align: center;
  margin: 0 0 33px 0;
  font-size: 20px;

  * {
    margin: 0;
  }

  p {
    color: rgb(83, 121, 136);
    font-size: 15px;
    margin: 5px 0 0 0;
  }
}

.toggle-section {
  display: flex;
  align-items: center;
  align-content: center;
  border-bottom: 1px solid #adc1cb;
  height: 60px;

  label {
    width: 100%;
    margin: 0 0 0 15px;
  }

  .edit {
    background: transparent;
    font-size: 15px;
    color: #006ba3;
    border: none;
  }
}

.close {
  background: transparent;
  border: none;

  svg {
    font-size: 31px;
  }
}

.controls {
  width: 100%;
  height: 58px;
}
</style>
